import React from 'react';
import Icon from '../../../components/AppIcon';

const EmailConfirmation = ({ customerEmail }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 mb-6">
      <div className="flex items-start space-x-4">
        <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon name="Mail" size={24} className="text-primary" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-foreground mb-2">Email Confirmation Sent</h3>
          <p className="text-sm text-muted-foreground mb-3">
            A confirmation email with your order details and tracking information has been sent to:
          </p>
          <p className="font-medium text-foreground bg-muted px-3 py-2 rounded-lg inline-block">
            {customerEmail}
          </p>
          <div className="mt-4 p-4 bg-background border border-border rounded-lg">
            <h4 className="font-medium text-foreground mb-2 flex items-center">
              <Icon name="HelpCircle" size={16} className="mr-2 text-primary" />
              Need Help?
            </h4>
            <p className="text-sm text-muted-foreground mb-2">
              If you have any questions about your order, please contact our customer service team:
            </p>
            <div className="space-y-1 text-sm">
              <p className="text-foreground">
                <Icon name="Phone" size={14} className="inline mr-2" />
                1-800-SHOP-NOW (1-800-746-7669)
              </p>
              <p className="text-foreground">
                <Icon name="Mail" size={14} className="inline mr-2" />
                support@DevOra.com
              </p>
              <p className="text-muted-foreground">
                <Icon name="Clock" size={14} className="inline mr-2" />
                Available 24/7
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailConfirmation;